import { GrossMarginRequestDetail } from "@/services/gross-margin-requests.service";
import { AppColors } from "@/styles/colors";
import { Flex, Grid, GridItem, Text } from "@chakra-ui/react";
import { StripeRow } from "./StripeRow";
import { RequestStatusBadge } from "@/components/common/section-components/badge/RequestStatusBadge";
import { GrossMarginRequestStatus } from "@/constants/entity-status";
import { RequestedHarvestList } from "./RequestedHarvestList";
import { ProducerObservation } from "./ProducerObservation";
import { ReportDisplay } from "./ReportDisplay";

interface Props {
    detail?: GrossMarginRequestDetail | null
}

export const MBPMainData = ({ detail }: Props) => {
    if (!detail) return null;
     return (
       <Flex flexDir="column" gap="20px" paddingTop="8px">
         {/* Main data — two cards with striped rows */}
         <Grid templateColumns="repeat(2, 1fr)" gap={18}>
           {/* Left card */}
           <GridItem>
             <Flex
               flexDir="column"
               padding="12px"
               height="100%"
               border={`1px solid ${AppColors.WHITE_BORDER_1}`}
               borderRadius="12px"
             >
               <Text
                 className="amd-card-title"
                 paddingBottom="10px"
                 textTransform="uppercase"
                 paddingX="24px"
                 fontWeight={700}
               >
                 Detalle
               </Text>
               <Grid templateColumns="repeat(2, 1fr)">
                 <StripeRow label="Titular cuenta" striped>
                   <Text className="account-value-label">{detail.titularCuenta ?? "-"}</Text>
                 </StripeRow>
                 <StripeRow label="Sucursal">
                   <Text className="account-value-label">{detail.sucursal ?? "-"}</Text>
                 </StripeRow>
                 <StripeRow label="Establecimiento" striped>
                   <Text className="account-value-label">{detail.procedencia}</Text>
                 </StripeRow>
               </Grid>
             </Flex>
           </GridItem>
   
           {/* Right card */}
           <GridItem>
             <Flex
               flexDir="column"
               padding="12px"
               height="100%"
               border={`1px solid ${AppColors.WHITE_BORDER_1}`}
               borderRadius="12px"
             >
               <Text
                 className="amd-card-title"
                 paddingBottom="10px"
                 textTransform="uppercase"
                 paddingX="24px"
                 fontWeight={700}
                 visibility="hidden"
               >
                 -
               </Text>
               <Grid templateColumns="repeat(2, 1fr)">
                 <StripeRow label="Hectáreas" striped>
                   <Text className="account-value-label">
                     {detail.hectareas != null ? `${detail.hectareas} ha` : "-"}
                   </Text>
                 </StripeRow>
                 <StripeRow label="Tipo de campo">
                   <Text className="account-value-label">{detail.tipoCampo ?? "-"}</Text>
                 </StripeRow>
                 <StripeRow label="Estado" striped>
                   <RequestStatusBadge
                     status={detail.estado as GrossMarginRequestStatus}
                     noPaddingY
                   />
                 </StripeRow>
               </Grid>
             </Flex>
           </GridItem>
         </Grid>
   
         {/* Cultivos solicitados */}
         {Boolean(detail.cultivos?.length) && <RequestedHarvestList detail={detail} />}
   
         {/* Observación del productor */}
         {Boolean(detail.observacionProductor) && <ProducerObservation detail={detail} />}
   
         {/* Informe — solo visible cuando la solicitud está Confirmada */}
         {detail.estado === GrossMarginRequestStatus.CONFIRMED && <ReportDisplay detail={detail} />}
       </Flex>
     );
}